import { createContext, useContext, useState, useEffect } from "react"

// Crear el contexto de autenticación
const AuthContext = createContext()

// Proveedor del contexto
export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [loading, setLoading] = useState(true) // Nuevo estado para controlar la carga

  // Cargar el estado de autenticación desde localStorage al montar el componente
  useEffect(() => {
    const storedAuth = localStorage.getItem("isAuthenticated")
    const storedActivo = localStorage.getItem("activo");

    if (storedAuth === "true" && storedActivo === "true") {
      setIsAuthenticated(true)
    }
    setLoading(false) // Indicar que la verificación ha terminado
  }, [])

  const login = () => {
    setIsAuthenticated(true)
    localStorage.setItem("isAuthenticated", "true")
  }

  const logout = () => {
    setIsAuthenticated(false)
    localStorage.removeItem("isAuthenticated")
    // También limpiar otros datos del usuario
    localStorage.removeItem("usuario")
    localStorage.removeItem("correo")
    localStorage.removeItem("rolActual")
    localStorage.removeItem("activo");
    localStorage.removeItem("jwtToken")
  }

  return <AuthContext.Provider value={{ isAuthenticated, login, logout, loading }}>{children}</AuthContext.Provider>
}

// Hook para acceder a la autenticación - ESTE ERA EL QUE FALTABA
export const useAuth = () => {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider")
  }
  return context
}
